/**
 * Returns the string passed to it. If using VSCode install `bierner.lit-html`
 * to enable HTML syntax highlighting when using this function.
 *
 * @example html`
 *   <div>Hello!</div>
 * `
 */
const html = String.raw

export class ScrollRevealer extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.safeZone = 50

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.innerHTML = html`
      <style>
        [data-scroll-revealer-el='anchor'] {
          position: absolute;
          height: ${this.safeZone}px;
          width: 100%;
          top: 0;
          left: 0;
        }
      </style>

      <div data-scroll-revealer-el="anchor"></div>

      <slot />
    `
  }

  setupListeners () {
    super.setupListeners()

    this.observer = new IntersectionObserver(this.handleObservation.bind(this))

    this.observer.observe(this.anchor)
  }

  /** @type {IntersectionObserverCallback} */
  handleObservation (entries) {
    const isSafe = entries.some(entry => entry.isIntersecting)

    this.toggleAttribute('safe', isSafe)
  }

  get anchor () {
    return this.shadowRoot.querySelector('[data-scroll-revealer-el="anchor"]')
  }
}

if (!customElements.get('scroll-revealer')) {
  customElements.define('scroll-revealer', ScrollRevealer)
}
